export const jiraViewSample = {
    'timestamp': 1631174979790,
    'webhookEvent': 'jira:issue_created',
    'issue_event_type_name': 'issue_created',
    'user': {
        'accountId': '613011cf45cd76006a9e6b0e',
        'displayName': 'TestUser',
        'active': true,
        'timeZone': 'Etc/GMT'
    },
    'issue': {
        'id': '10038',
        'key': 'TEST-18',
        'fields': {
            'issuetype': {
                'id': '10007',
                'name': 'Task'
            },
            'project': {
                'id': '10000',
                'key': 'TEST',
                'name': 'TESTProject'
            },
            'created': '2021-09-09T08:09:39.593+0000',
            'priority': {
                'name': 'Medium',
                'id': '3'
            },
            'assignee': null,
            'updated': '2021-09-09T08:09:39.593+0000',
            'status': {
                'name': 'Open',
                'id': '1',
                'statusCategory': {
                    'id': 2,
                    'key': 'new',
                    'name': 'New'
                }
            },
            'description': 'test',
            'summary': 'JiraTest#01',
            'creator': {
                'accountId': '613011cf45cd76006a9e6b0e',
                'displayName': 'TestUser',
                'active': true,
                'timeZone': 'Etc/GMT'
            }
        }
    }
};

export const jiraSample = {
    'webhookEvent': 'jira:issue_created',
    'issue.key': 'TEST-18',
    'issue::fields::project.key': 'TEST',
    'issue::fields.summary': 'JiraTest#01',
    'issue::fields::priority.name': 'Medium',
    'issue::fields::status.name': 'Open',
    'issue::fields::status::statusCategory.name': 'New'
};



// WEBPACK FOOTER //
// ./src/app/views/main/integration/cstmSmry.sample/jira.ts